<template>
  <div class="menu">
    <div class="menu__content">
      <!-- home button -->
      <MenuBox :data="homeButton"></MenuBox>
      <!-- sources -->
      <MenuBox
        v-for="(type, index) in sourcesTypes"
        :key="index"
        :data="getItemsBySourceType(type)"
        :title="type"
        linkType="router"
      ></MenuBox>

      <MenuBox
        linkType="modal"
        :data="modalLinks"
        :useMenuItem="false"
      ></MenuBox>

      <MenuBox
        linkType="external"
        :data="externalLinks"
        :useMenuItem="false"
      ></MenuBox>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MenuBox from "@/components/MenuBox.vue";

export default {
  components: {
    MenuBox,
  },
  data() {
    return {
      sourcesTypes: ["Renewables", ""],
    };
  },
  computed: {
    withSocialShare() {
      return this.landingIndex > -1;
    },
    content() {
      return this.$t("headerAndMenu").items;
    },
    homeButton() {
      return [this.content.find((x) => x.linkType === "router")];
    },
    modalLinks() {
      return this.content.filter((x) => x.linkType === "modal" && !x.hidden);
    },
    externalLinks() {
      return this.content.filter((x) => x.linkType === "external");
    },

    ...mapGetters({
      mainSourcesRegistry: "ui/mainSourcesRegistry",
      landingIndex: "scroller/landingIndex",
    }),
  },

  methods: {
    getItemsBySourceType(sourceType) {
      let res = [];

      const sourceArray = this.mainSourcesRegistry.filter(
        (x) => x.sourceType.trim() == sourceType.trim()
      );

      sourceArray.forEach((x) => {
        const obj = {
          title: x.name,
          key: x.key,
          text: x.name,
          routeParam: x.key,
          landingIndex: x.landingIndex,
          linkType: "router",
        };
        res.push(obj);
      });

      return res;
    },
    ...mapActions({
      toggleMenu: "ui/toggleMenu",
    }),
  },
};
</script>

<style lang="scss" scoped>
.menu {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &__content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 10vh;
    width: 100%;
    height: 100vh;
    margin-left: 23.47vw;
  }
}

.tablet {
  .menu {
    &__content {
      padding-top: 13.1vh;
      margin-left: 25vw;
    }
  }
}
</style>
